import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useRecoilValue } from 'recoil'
import { profitsState } from '../../states/profits-state'
import { ProfitsTableItem } from '../../components/profits-table/profits-table-item'
import ProfitForm from '../../forms/profit-form'

const TradeProfitsScreen = (): ReactElement => {
  const profits = useRecoilValue(profitsState) || []

  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Trade Profits'} />
      <table className="table table-compact w-full">
        <thead>
          <tr>
            <th>Realized At</th>
            <th>Amount</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {profits?.map((profit) => (
            <ProfitsTableItem key={profit.id} id={profit.id} />
          ))}
        </tbody>
      </table>

      {profits?.length === 0 && 'No earnings yet'}

      <ProfitForm />
    </Flexbox>
  )
}

export default TradeProfitsScreen